import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import useAppDispatch from "hooks/useAppDispatch";
import useAppSelector from "hooks/useAppSelector";
import { getFacility } from "features/facility/facilityAction";
import { PRINCIPAL } from "config/keywords";
import { ACCOUNT_PATH } from "router/pathName";

const FacilityLabel = () => {
  const { facility } = useAppSelector((state) => state.facility);
  const { user } = useAppSelector((state) => state.user);
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const fetchFacility = () => !facility && dispatch(getFacility());
  const callFetchFacility = useCallback(fetchFacility, [
    facility,
    dispatch,
    getFacility,
  ]);
  useEffect(() => {
    callFetchFacility();
  }, [callFetchFacility]);

  const accountLabel =
    user?.role === PRINCIPAL
      ? t("_header._administrator_account")
      : [user?.last_name, user?.first_name].filter(Boolean).join(" ");

  return (
    <div className="min-w-0 text-right leading-tight text-black">
      <h4 className="truncate text-center text-sm font-semibold">
        {facility ? facility.name : ""}
      </h4>
      <div className="pt-1">
        <Link
          to={ACCOUNT_PATH}
          className="inline-flex max-w-full items-center rounded-full border border-[#9B9B9B] px-3 py-1 text-[11px] font-semibold text-black"
        >
          <span className="truncate">{accountLabel}</span>
        </Link>
      </div>
    </div>
  );
};

export default FacilityLabel;
